import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { BookingsSheetBase } from './BookingsSheet'

import { dateSelector } from 'reduxModules/selectors/DateSelectors'
import { routeNameSelector, infoForDriversSelector } from 'reduxModules/selectors/RouteSelectors'

const mapStateToProps = createStructuredSelector({
  date: dateSelector,
  routeName: routeNameSelector,
  infoForDrivers: infoForDriversSelector,
})

export const BookingsSheet = connect(mapStateToProps)(BookingsSheetBase)



// WEBPACK FOOTER //
// ./src/components/BookingsSheet/index.js